import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import clsx from 'clsx';
import { $profileFeatureStore, $profileStore } from '@lib/store/profile';
import { FormatUtils } from '@shared/utils';
import type { UserProfileResponse } from '@shared/api/rest/users';
import { Button, ColorsEnum, Icon, Text } from '@shared/widgets';
import SettingIcon from '@assets/icons/setting.svg';
import ChevronIcon from '@assets/icons/chevron.svg';
import { EditDetailsModal } from '../widgets';

export const UserCorporateOptions = () => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);
  const profileStore = useUnit($profileStore.store);

  const [options, setOptions] = useState<boolean>(true);
  const [editDetails, setEditDetails] = useState<boolean>(false);
  const [data, setData] = useState<UserProfileResponse>();

  useEffect(() => {
    if (profileStore && !data) setData(profileStore.data as UserProfileResponse);
  }, []);

  useEffect(() => {
    if (profileStore.data && !profileStore.loading) setData(profileStore.data);
  }, [profileStore.data]);

  return (
    <div className='mb-2 pb-2 border-b-gray-200 border-b last:border-b-0 last:mb-0 last:pt-0'>
      <div className='flex items-center min-h-12 px-0 py-4 cursor-pointer' onClick={() => setOptions(!options)}>
        <div
          className={clsx(
            'flex-none flex items-center justify-center transition ease-out mr-4',
            options ? 'text-primary' : 'text-slate dark:text-white',
          )}
        >
          <Icon icon={<SettingIcon />} color='inherit' />
        </div>
        <Text className='flex-auto'>Corporate options</Text>
        <div className={clsx('flex items-center justify-center transition ease-out', options && 'rotate-180')}>
          <Icon icon={<ChevronIcon />} className='-rotate-90' />
        </div>
      </div>
      <div className={clsx(!options ? 'hidden' : 'block pt-3')}>
        <div className='mb-5'>
          <div className='flex justify-between gap-2'>
            <Text size='sm' color={ColorsEnum.Secondary}>
              E-mail
            </Text>
            <Text weight='medium' size='sm'>
              {data?.emailAddress}
            </Text>
          </div>
        </div>
        <div className='mb-5'>
          <div className='flex justify-between gap-2'>
            <Text size='sm' color={ColorsEnum.Secondary}>
              Phone number
            </Text>
            <Text weight='medium' size='sm'>
              {data?.phoneAreaCode && FormatUtils.toPhoneFormat(data.phoneAreaCode, data?.phoneNumber)}
            </Text>
          </div>
        </div>
        <div className='mb-5'>
          {profileFeatureStore.data?.profileSettings.editDetails && (
            <Button color='outlined' fullWidth onClick={() => setEditDetails(true)}>
              Edit details
            </Button>
          )}
          <EditDetailsModal isOpen={editDetails} onClose={() => setEditDetails(false)} />
        </div>
      </div>
    </div>
  );
};
